module.exports = __webpack_public_path__ + "img/9_no.a70e47ae.svg";